export var CINCHCARE_ELIGIBLE_DAYS_AFTER_DELIVERY = 100;
export var SERVICE_AND_WARRANTY_ELIGIBLE_DAYS_AFTER_ORDER = 14;
